/**
 * Determines the car condition for finance calculator based on post data
 * @param postData - The post data object containing car details
 * @returns 'chinese' | 'used' | 'new'
 */
export var getFinanceCalculatorCarCondition = function getFinanceCalculatorCarCondition(postData) {
  var _postData$details, _postData$details2, _postData$details2$de, _postData$details2$de2, _postData$details_car, _postData$details_car2;
  // Extract car details from either nested or direct structure
  var details = (postData === null || postData === void 0 ? void 0 : postData.details) || postData;
  var isChineseNested = postData === null || postData === void 0 ? void 0 : (_postData$details = postData.details) === null || _postData$details === void 0 ? void 0 : _postData$details.is_chinese;
  var isChineseDirect = postData === null || postData === void 0 ? void 0 : postData.is_chinese;
  var isNewNested = postData === null || postData === void 0 ? void 0 : (_postData$details2 = postData.details) === null || _postData$details2 === void 0 ? void 0 : (_postData$details2$de = _postData$details2.details_card) === null || _postData$details2$de === void 0 ? void 0 : (_postData$details2$de2 = _postData$details2$de.is_new) === null || _postData$details2$de2 === void 0 ? void 0 : _postData$details2$de2.id;
  var isNewDirect = postData === null || postData === void 0 ? void 0 : (_postData$details_car = postData.details_card) === null || _postData$details_car === void 0 ? void 0 : (_postData$details_car2 = _postData$details_car.is_new) === null || _postData$details_car2 === void 0 ? void 0 : _postData$details_car2.id;

  // Check if it's a Chinese car
  if (isChineseNested && isNewNested || isChineseDirect && isNewDirect) {
    return 'chinese';
  }

  // Check if it's a used car (is_new is false or 0)
  if (isNewNested === false || isNewNested === 0 || isNewDirect === false || isNewDirect === 0) {
    return 'used';
  }

  // Default to new car
  return 'new';
};